import React from 'react';
import PropertyDialog from './Property';
import VehicleDialog from './Vehicles';

const AssetDialog = (props: { assetType: 'realEstate' | 'vehicle'; linkTo?: string }) => {
  const { assetType, linkTo } = props;
  if (assetType === 'realEstate') {
    return <PropertyDialog linkTo={linkTo} />;
  }
  if (assetType === 'vehicle') {
    return <VehicleDialog linkTo={linkTo} />;
  }
  return null;
};

export default AssetDialog;
